export interface RdioFilter {
  id: string;
  label: string;
  color?: string;
  description?: string;
}

export type RadioFiltersGroup = Record<string, RdioFilter>;

export const mainRadioFilters = (days: number): RadioFiltersGroup => ({
  all: {
    id: 'all',
    label: 'Все',
    description: 'Показывает все фразы из списка',
  },
  found: {
    id: 'found',
    label: 'Найдено',
    description: 'Показывает все фразы, по которым можно найти вашу карточку в выдаче',
  },
  not_found: {
    id: 'not_found',
    label: 'Не найдено',
    description: `Показывает фразы, по которым не было индексации за последние ${days} дней`,
  },
  in_promotion: {
    id: 'in_promotion',
    label: 'Буст',
    description: `Показывает все фразы, по которым шёл буст за последние ${days} дней`,
  },
  not_in_promotion: {
    id: 'not_in_promotion',
    label: 'Нет буста',
    description: `Показывает фразы, по которым не было буста за последние ${days} дней`,
  },
  promotion_today: {
    id: 'promotion_today',
    label:'Буст сегодня',
    description: 'Показывает фразы, по которым сегодня пошел буст',
  },
  not_promotion_today: {
    id: 'not_promotion_today',
    label:'Нет буста сегодня',
    description: 'Показывает фразы, по которым сегодня нет буста',
  },
  became: {
    id: 'became',
    label: 'Появились',
    color: '#7AC70C',
  },
  became_today: {
    id: 'became_today',
    label: 'Появились сегодня',
    color: '#7AC70C',
    description: 'Показывает фразы, по которым сегодня появилась индексация',
  },
  not_found_today: {
    id: 'not_found_today',
    label: 'Вылетели',
    color: '#FC4848',
    description: 'Показывает фразы, по которым вы перестали индексироваться',
  },
  out_today: {
    id: 'out_today',
    label: 'Вылетели сегодня',
    color: '#FC4848',
    description: 'Показывает фразы, по которым вы перестали индексироваться сегодня',
  },
  not_found_season: {
    id: 'not_found_season',
    label: 'Нет сезона',
    color: '#FEB82C',
  },
  not_found_sex: {
    id: 'not_found_sex',
    label: 'Нет пола',
    color: '#FEB82C',
  },
  not_found_subject: {
    id: 'not_found_subject',
    label: 'Нет предмета',
    description: 'Показывает фразы, по которым не выдается предмет, указанный в карточке товара',
    color: '#FEB82C',
  },
  not_found_brand: {
    id: 'not_found_brand',
    label: 'Бренды',
    color: '#FEB82C',
  },
});

export const mainRadioShelveFilters = (days: number): RadioFiltersGroup => ({
  all: {
    id: 'all',
    label: 'Все',
    description: 'Показывает все артикулы из списка',
  },
  found: {
    id: 'found',
    label: 'Найдено',
    description: 'Показывает все артикулы, по которым можно найти вашу карточку в выдаче',
  },
  not_found: {
    id: 'not_found',
    label: 'Не найдено',
    description: `Показывает артикулы, по которым не было индексации за последние ${days} дней`,
  },
  in_promotion: {
    id: 'in_promotion',
    label: 'Буст',
    description: `Показывает все артикулы, по которым шёл буст за последние ${days} дней`,
  },
  not_in_promotion: {
    id: 'not_in_promotion',
    label: 'Нет буста',
    description: `Показывает артикулы, по которым не было буста за последние ${days} дней`,
  },
  promotion_today: {
    id: 'promotion_today',
    label:'Буст сегодня',
    description: 'Показывает артикулы, по которым сегодня пошел буст',
  },
  not_promotion_today: {
    id: 'not_promotion_today',
    label:'Нет буста сегодня',
    description: 'Показывает артикулы, по которым сегодня нет буста',
  },
  became: {
    id: 'became',
    label: 'Появились',
    color: '#7AC70C',
  },
  became_today: {
    id: 'became_today',
    label: 'Появились сегодня',
    color: '#7AC70C',
    description: 'Показывает артикулы, по которым сегодня появилась индексация',
  },
  not_found_today: {
    id: 'not_found_today',
    label: 'Вылетели',
    color: '#FC4848',
    description: 'Показывает артикулы, по которым вы перестали индексироваться',
  },
  out_today: {
    id: 'out_today',
    label: 'Вылетели сегодня',
    color: '#FC4848',
    description: 'Показывает артикулы, по которым вы перестали индексироваться сегодня',
  },
  not_found_season: {
    id: 'not_found_season',
    label: 'Нет сезона',
    color: '#FEB82C',
  },
  not_found_sex: {
    id: 'not_found_sex',
    label: 'Нет пола',
    color: '#FEB82C',
  },
  not_found_subject: {
    id: 'not_found_subject',
    label: 'Нет предмета',
    description: 'Показывает фразы, по которым не выдается предмет, указанный в карточке товара',
    color: '#FEB82C',
  },
  not_found_brand: {
    id: 'not_found_brand',
    label: 'Бренды',
    color: '#FEB82C',
  },
});

const topDescription =
  'Показывает фразы, по которым вы занимаете позицию в выдаче, соответствующую диапазону выбранного ТОПа';

const topShelvesDescription = 'Показывает артикулы, по которым вы занимаете позицию в выдаче, соответствующую диапазону выбранного ТОПа';

export const topRadioFilters: RadioFiltersGroup = {
  all: {
    id: 'all',
    label: 'Все',
    color: '#178AF1',
    description: 'Показывает все фразы из списка',
  },
  top_1: {
    id: 'top_1',
    label: 'ТОП-1',
    color: '#178AF1',
    description: topDescription,
  },
  top_5: {
    id: 'top_5',
    label: 'ТОП-5',
    color: '#178AF1',
    description: topDescription,
  },
  top_10: {
    id: 'top_10',
    label: 'ТОП-10',
    color: '#178AF1',
    description: topDescription,
  },
  top_50: {
    id: 'top_50',
    label: 'ТОП-50',
    color: '#178AF1',
    description: topDescription,
  },
  top_100: {
    id: 'top_100',
    label: 'ТОП-100',
    color: '#178AF1',
    description: topDescription,
  },
  top_500: {
    id: 'top_500',
    label: 'ТОП-500',
    color: '#178AF1',
    description: topDescription,
  },
};

export const topRadioShelveFilters: RadioFiltersGroup = {
  all: {
    id: 'all',
    label: 'Все',
    color: '#178AF1',
    description: 'Показывает все артикулы из списка',
  },
  top_1: {
    id: 'top_1',
    label: 'ТОП-1',
    color: '#178AF1',
    description: topShelvesDescription,
  },
  top_5: {
    id: 'top_5',
    label: 'ТОП-5',
    color: '#178AF1',
    description: topShelvesDescription,
  },
  top_10: {
    id: 'top_10',
    label: 'ТОП-10',
    color: '#178AF1',
    description: topShelvesDescription,
  },
  top_50: {
    id: 'top_50',
    label: 'ТОП-50',
    color: '#178AF1',
    description: topShelvesDescription,
  },
  top_100: {
    id: 'top_100',
    label: 'ТОП-100',
    color: '#178AF1',
    description: topShelvesDescription,
  },
};

export const allRadioFilters = {
  ...mainRadioFilters(14),
  ...topRadioFilters,
};

export const comparisonsSecondaryRadioFilters: RadioFiltersGroup = {
  all: {
    id: 'all',
    label: 'Все',
    description: 'Показывает все фразы из списка',
  },
  found: {
    id: 'found',
    label: 'Найдено',
    description: 'Показывает фразы, по которым индексируется ваша карточка ',
  },
  not_found: {
    id: 'not_found',
    label: 'Не найдено',
    description:
      'Показывает фразы, по которым ваша карточка не индексируется, но карточки выбранных конкурентов индексируются',
  },
  behind: {
    id: 'behind',
    label: 'Отстаю',
    description:
      'Показывает фразы, по которым ваша карточка занимает позицию хуже, чем выбранные конкуренты',
  },
  in_front: {
    id: 'in_front',
    label: 'Опережаю',
    description:
      'Показывает фразы, по которым ваша карточка занимает позицию лучше, чем выбранные конкуренты',
  },
};

export const shelvesSecondaryRadioFilters: RadioFiltersGroup = {
  all: {
    id: 'all',
    label: 'Все',
    description: 'Показывает все артикулы из списка',
  },
  found: {
    id: 'found',
    label: 'Найдено',
    description: 'Показывает все артикулы, по которым можно найти вашу карточку в выдаче',
  },
  not_found: {
    id: 'not_found',
    label: 'Не найдено',
    description:
      'Показывает артикулы, по которым ваша карточка не индексируется, но карточки выбранных конкурентов индексируются',
  },
  behind: {
    id: 'behind',
    label: 'Отстаю',
    description:
      'Показывает артикулы, по которым ваша карточка занимает позицию хуже, чем выбранные конкуренты',
  },
  in_front: {
    id: 'in_front',
    label: 'Опережаю',
    description:
      'Показывает артикулы, по которым ваша карточка занимает позицию лучше, чем выбранные конкуренты',
  },
};

type PlaceRangeRadioGroup = Record<
  string,
  RdioFilter & {
    min: number;
    max: number;
    serverKey: string;
    description?: string;
  }
>;

const multiplePlacesText =
  'Занимаемые места фраз, на которых находится товар с таким же предметом как у вас на WB';

export const placeRangeRadioFilters: PlaceRangeRadioGroup = {
  all: {
    min: 1,
    max: 999999,
    id: 'all',
    label: 'Все',
    serverKey: 'all',
    description:
      'В списках “Места” представлены фразы, по которым ваши конкуренты занимали соответствующее место позиции с вашим товаром',
  },
  top_1_1: {
    min: 1,
    max: 1,
    id: 'top_1_1',
    label: '1 МЕСТО',
    color: '#178AF1',
    serverKey: 'top1',
    description:
      'Занимаемое место фразы, на котором находится товар с таким же предметом как у вас на WB',
  },
  top_2_5: {
    min: 2,
    max: 5,
    id: 'top_2_5',
    label: '2 - 5 МЕСТО',
    color: '#178AF1',
    serverKey: 'top2-5',
    description: multiplePlacesText,
  },
  top_6_10: {
    min: 6,
    max: 10,
    id: 'top_6_10',
    label: '6 - 10 МЕСТО',
    color: '#178AF1',
    serverKey: 'top6-10',
    description: multiplePlacesText,
  },
  top_11_50: {
    min: 11,
    max: 50,
    id: 'top_11_50',
    label: '11 - 50 МЕСТО',
    color: '#178AF1',
    serverKey: 'top11-50',
    description: multiplePlacesText,
  },
  top_51_100: {
    min: 51,
    max: 100,
    id: 'top_51_100',
    label: '51 - 100 МЕСТО',
    color: '#178AF1',
    serverKey: 'top51-100',
    description: multiplePlacesText,
  },
  top_101_500: {
    min: 101,
    max: 500,
    id: 'top_101_500',
    label: '101 - 500 МЕСТО',
    color: '#178AF1',
    serverKey: 'top101-500',
    description: multiplePlacesText,
  },
};
